import React from 'react';
import { Navigation } from '@/components/Navigation';
import { Hero } from '@/components/Hero';
import { ElCercado } from '@/components/ElCercado';
import { ElOficio } from '@/components/ElOficio';
import { LosArtesanos } from '@/components/LosArtesanos';
import { LasPiezas } from '@/components/LasPiezas';
import { VisitasClases } from '@/components/VisitasClases';
import { Visita } from '@/components/Visita';
import { Footer } from '@/components/Footer';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <ElCercado />
      <ElOficio />
      <LosArtesanos />
      <LasPiezas />
      <VisitasClases />
      <Visita />
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
